import { axios } from '@ori/axios';
import { isNonNullable } from '@ori/ts-utils';
import { handleResponse } from './handleResponse';
import { isEmptyObject } from './isEmptyObject';
/**
 * Fetches data from a GraphQL server using axios library.
 *
 * @typeParam Data The expected data type returned from the GraphQL server.
 * @typeParam Variables The type of variables that the GraphQL query takes.
 * @param options Request options object.
 * @returns A promise that resolves to the requested data or rejects with an error.
 */
export async function fetchGraphql({
  query,
  variables,
  url,
  headers,
  timeout = 5000,
  // eslint-disable-next-line no-console -- default error handler
  onError = error => console.error(error)
}) {
  const requestData = {
    query,
    ...(variables && !isEmptyObject(variables) && {
      variables
    })
  };
  try {
    // @ts-expect-error -- exactOptionalPropertyTypes -- not compatible with axios
    const response = await axios.post('/graphql', requestData, {
      baseURL: new URL(url).origin,
      headers,
      timeout
    });
    return handleResponse(response, {
      onSuccess: ({
        data: {
          data
        }
      }) => {
        if (isNonNullable(data)) {
          return data;
        }
        throw new Error('No response data from GQL server');
      },
      onError: ({
        statusText
      }) => {
        throw new Error(statusText);
      }
    });
  } catch (error) {
    onError(error);
    throw new Error('Error from GQL server');
  }
}
//# sourceMappingURL=fetchGraphql.js.map